// extracted by mini-css-extract-plugin
export default {"email-exists-alert":"CustomerDetailFields_email-exists-alert__zfUiM"};